'use client';

import { TableColumnAnchor, tableColumnAnchorTag } from '@ni/nimble-components/dist/esm/table-column/anchor';
import { wrap } from '../../utilities/react-wrapper';

export { tableColumnAnchorTag };
export { type TableColumnAnchor };
export const NimbleTableColumnAnchor = wrap(TableColumnAnchor);
